import { render, staticRenderFns } from "./dialog-checkpassword.vue?vue&type=template&id=6230ac1c&"
import script from "./dialog-checkpassword.vue?vue&type=script&lang=js&"
export * from "./dialog-checkpassword.vue?vue&type=script&lang=js&"
import style0 from "./dialog-checkpassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports